import * as constants from '../constants';

const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').Account} Account
 * @typedef {import('./state').AccountConfiguration} AccountConfiguration
 */

/**
 * @param {State} state
 * @param {Account} obj
 */
export function setCurrentUser (state, obj) {
  if (obj && state.currentUser && obj.uid !== state.currentUser.uid) {
    throw new Error(`${nms}: Cannot change current user without signing out`);
  }

  // reset store on signout
  if (!obj) {
    state.currentUserConfig = null;
    state.memberships = [];
    // unsubscribe watchers
    if (state.currentUserSub) state.currentUserSub.unsubscribe();
    if (state.deviceTokensSub) state.deviceTokensSub.unsubscribe();
  }

  // set new current user
  state.currentUser = obj || null;
}

/**
 * @param {State} state
 * @param {import('rxjs').Subscription} obj
 */
export function setCurrentUserSub (state, obj) {
  state.currentUserSub = obj || null;
}

/**
 * @param {State} state
 * @param {import('rxjs').Subscription} obj
 */
export function setDeviceTokensSub (state, obj) {
  state.deviceTokensSub = obj || null;
}

/**
 * @param {State} state
 * @param {AccountConfiguration} obj
 */
export function setCurrentUserConfig (state, obj) {
  state.currentUserConfig = obj || null;
}
